import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import { FF2, IconName, Info, UrlInput } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

export const WebSite = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.websites`
  })

  return (
    <Info label="22a. Website (URL) address">
      {fields.map((field, index2) => (
        <WebSiteItem key={field.id} index1={index} index2={index2} rowsNumber={fields.length} onDelete={remove} />
      ))}
      <IconButton icon={IconName.ADD_GREEN} onClick={() => append({ value: '' })} />
    </Info>
  )
}

const WebSiteItem = ({
  index1,
  index2,
  rowsNumber,
  onDelete
}: {
  index1: number
  index2: number
  rowsNumber: number
  onDelete: (index: number) => void
}) => {
  const { control } = useFormContext<SarEdit>()
  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => onDelete(index2),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <Controller
        name={`subjectsInfo.${index1 as 0}.websites.${index2 as 0}.value`}
        control={control}
        render={({ field }) => (
          <FormRow>
            <Col>
              <FF2 field={field} input={(props) => <UrlInput {...props} />} />
            </Col>
            {rowsNumber > 1 && <IconButton face="negative" icon={IconName.DELETE} onClick={startDeleting} />}
          </FormRow>
        )}
      />
    </>
  )
}
